import { CustomRouteObject } from '../../types/routes/Route.type';
import MainLayout from '../../layouts/MainLayout';
import Dashboard from '../../pages/Dashboard';
import user from './user';
import question from './question';
import admin from './admin';

const reactRoute: CustomRouteObject[] = [
  {
    id: 'root',
    path: '/',
    element: <MainLayout />,
    children: [
      {
        id: 'main',
        path: '/',
        element: <Dashboard />,
      },
    ],
  },
  user,
  question,
  admin,
];

export default reactRoute;
